






import { Prop, Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import ProgressContainer from "./ProgressContainer.vue";
import { Getter } from "vuex-class";
@Component({
  components: { ProgressContainer }
})
export default class AliasedRequestProgressContainer extends Vue {
  @Prop() private requestAlias!: string;
  @Getter("ui/isAnyAliasedRequestPending")
  private isAnyAliasedRequestPending!: (alias: string) => boolean;
}
